import $ from "jquery";
import "./../styles/main.scss";
// require('./woocommerce/Global');
var Plyr = require("plyr");
import Glide from "@glidejs/glide";
import { siblings } from '@glidejs/glide/src/utils/dom';
import Glightbox from "glightbox";
// require("./helpers/ihavecookies");
import { DataTable } from "simple-datatables";
import AOS from "aos";
require("jquery.scrollto");
var CustomActiveClass = function (Glide, Components, Events) {
    var Component = {
        mount: function () {
            this.changeActiveSlide();
        },
        changeActiveSlide: function () {
            var slide = Components.Html.slides[Glide.index];
            slide.classList.remove('is-next', 'is-prev');
            slide.classList.add('is-active');
            siblings(slide).forEach(function (sibling) {
                sibling.classList.remove('is-active', 'is-next', 'is-prev');
            });
            if (slide.nextElementSibling) {
                slide.nextElementSibling.classList.add('is-next');
            }
            if (slide.previousElementSibling) {
                slide.previousElementSibling.classList.add('is-prev');
            }
        }
    };
    Events.on('run', function () {
        Component.changeActiveSlide();
    });
    return Component;
};
$(document).ready(function () {
    var gl = Glightbox({});
    $('.player').each(function (k, e) {
        var player = new Plyr(e);
    });
    // const viewCookieBannerButton = document.querySelector(".view-cookie-banner");
    // if (viewCookieBannerButton !== void 0) {
    //     viewCookieBannerButton.addEventListener("click", (e) => {
    //         e.preventDefault();
    //         CookieConsentNode.showDetails();
    //     });
    // }
    $("body").on("click", "a[href^='#goto-']", function (e) {
        e.preventDefault();
        var node = $(e.currentTarget).attr("href").replace("goto-", "");
        var posY = $(node).offset().top - $("#main-header").height();
        if (posY >= 0) {
            $.scrollTo(posY, 400);
        }
    });
    $('body').on("click", ".shared-item", function (e) {
        e.preventDefault();
        window.open($(e.currentTarget).attr("href"), "", "width=500,height=350");
    });
    $("body").on("click", "#menu-switcher a", function (e) {
        e.preventDefault();
        $("#nav-main").toggleClass("show-menu");
        $(e.currentTarget).toggleClass("show-menu");
    });
    $("body").on("click", ".goTo", function (e) {
        var elm = $(e.currentTarget).attr("href");
        var posY = $(elm).offset().top - $("#main-header").height();
        $.scrollTo(posY, 400);
    });
    if ($('.carouselWrapper').length) {
        $('.carouselWrapper').each(function (k, e) {
            var customActiveClass = $(e).attr("data-custom-class") !== void 0 ? true : false;
            var gap = $(e).attr("data-gap") !== void 0 ? $(e).attr("data-gap") : 50;
            var view = $(e).attr("data-view") !== void 0 ? $(e).attr("data-view") : 2.5;
            var type = $(e).attr("data-type") !== void 0 ? $(e).attr("data-type") : "slider";
            var focus = $(e).attr("data-focus") !== void 0 ? $(e).attr("data-focus") : 0;
            var bound = $(e).attr("data-bound") !== void 0 ? $(e).attr("data-bound") : false;
            var autoplay = $(e).attr("data-autoplay") !== void 0 ? $(e).attr("data-autoplay") : false;
            var mobileGap = $(e).attr("data-mobile-gap") !== void 0 ? $(e).attr("data-mobile-gap") : 20;
            var mobileView = $(e).attr("data-mobile-view") !== void 0 ? $(e).attr("data-mobile-view") : 1;
            var mdGap = $(e).attr("data-md-gap") !== void 0 ? $(e).attr("data-md-gap") : gap;
            var mdView = $(e).attr("data-md-view") !== void 0 ? $(e).attr("data-md-view") : view;
            var smGap = $(e).attr("data-sm-gap") !== void 0 ? $(e).attr("data-sm-gap") : mdGap;
            var smView = $(e).attr("data-sm-view") !== void 0 ? $(e).attr("data-sm-view") : mdView;
            var glide = new Glide(e, {
                type: type,
                focusAt: focus,
                perView: view,
                gap: gap,
                startAt: 0,
                // bound: bound,
                bound: true,
                autoplay: autoplay,
                breakpoints: {
                    1050: {
                        gap: mdGap,
                        perView: mdView
                    },
                    768: {
                        gap: smGap,
                        perView: smView
                    },
                    600: {
                        focusAt: "center",
                        gap: mobileGap,
                        perView: mobileView
                    }
                }
            });
            if (customActiveClass) {
                // glide.mount({
                //     'CustomActiveClass': CustomActiveClass,
                // });
                glide.mount();
            }
            else {
                glide.mount();
            }
        });
    }
    if ($('.page-template-tpl-home').length) {
        $('.gallery .cover-item').hover(function (e) {
            var attr = $(e.currentTarget).children(".global").attr("data-chapter");
            $('.map').find(".item[data-chapter='" + attr + "'").addClass("visible");
            $(e.currentTarget).addClass("active");
        }, function (e) {
            var attr = $(e.currentTarget).children('.global').attr("data-chapter");
            $(e.currentTarget).removeClass("active");
            $('.map').find(".item[data-chapter='" + attr + "'").removeClass("visible");
        });
        $('.gallery a.global').on("click", function (e) {
            e.preventDefault();
            $('.map').find(".item.visible").removeClass("visible");
            $('.gallery .active').removeClass("active");
            $(e.currentTarget).parent().addClass("active");
            var attr = $(e.currentTarget).attr("data-chapter");
            $('.map').find(".item[data-chapter='" + attr + "'").addClass("visible");
            // $.scrollTo(".map", 400);
        });
        $("#projects").on("click", ".header", function (e) {
            $.scrollTo("#projects-list", 400);
        });
    }
    if ($('.page-template-tpl-availability').length) {
        var dataTable = new DataTable("#properties", {
            searchable: false,
            fixedHeight: true,
            paging: false
        });
    }
    if ($(window).width() < 600) {
        $("[data-aos='fade-left']").attr("data-aos", "fade-up");
    }
    $("a.not-available").on("click", function (e) {
        e.preventDefault();
    });
    AOS.init();
    setTimeout(function () { AOS.refresh(); }, 500);
});
